<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <hm-table :id="$attrs['id']" :hover="false" columns="5" min-width="700px">
    <template slot="table-head">
      <div v-if="created" class="hm-table__th">{{ $t('table.activePaymentProcess.created') }}</div>
      <div v-if="cancelled" class="hm-table__th">{{ $t('table.activePaymentProcess.cancelled') }}</div>
      <div class="hm-table__th">{{ $t('table.activePaymentProcess.paymentMethod') }}</div>
      <div class="hm-table__th">{{ $t('table.activePaymentProcess.description') }}</div>
      <div class="hm-table__th text-right">{{ $t('table.activePaymentProcess.amount') }}</div>
      <div class="hm-table__th text-right">{{ $t('table.activePaymentProcess.total') }}</div>
      <div class="hm-table__th text-right">{{ $t('table.activePaymentProcess.actions') }}</div>
    </template>
    <template slot="default">
      <template v-for="(payment, index) in paymentProcess.payments">
        <div v-if="payment.paymentMethod === 'CreditCard'" :class="[{'hm-table__td--has-child-rows': index+1 < paymentProcess.payments.length}]" class="hm-table__td">{{ $t(`PaymentSource.${payment.paymentSource}`) }} // {{ $t(`PaymentMethod.${payment.paymentMethod}`) }} // {{ payment.creditCardType }}</div>
        <div v-else-if="payment.paymentSource === 'NotApplicable'" :class="[{'hm-table__td--has-child-rows': index+1 < paymentProcess.payments.length}]" class="hm-table__td">{{ $t(`PaymentMethod.${payment.paymentMethod}`) }}</div>
        <div v-else :class="[{'hm-table__td--has-child-rows': index+1 < paymentProcess.payments.length}]" class="hm-table__td">{{ $t(`PaymentSource.${payment.paymentSource}`) }} // {{ $t(`PaymentMethod.${payment.paymentMethod}`) }}</div>
        <div v-if="!isEmpty(payment.label) && isEmpty(payment.transactionReference)" :class="[{'hm-table__td--has-child-rows': index+1 < paymentProcess.payments.length}]" class="hm-table__td">{{ payment.label }}</div>
        <div v-else-if="isEmpty(payment.label) && !isEmpty(payment.transactionReference)" :class="[{'hm-table__td--has-child-rows': index+1 < paymentProcess.payments.length}]" class="hm-table__td">{{ payment.transactionReference }}</div>
        <div v-else-if="!isEmpty(payment.label) && !isEmpty(payment.transactionReference)" :class="[{'hm-table__td--has-child-rows': index+1 < paymentProcess.payments.length}]" class="hm-table__td">{{ payment.label }} // {{ payment.transactionReference }}</div>
        <div v-else :class="[{'hm-table__td--has-child-rows': index+1 < paymentProcess.payments.length}]" class="hm-table__td"></div>
        <div :class="[{'hm-table__td--has-child-rows': index+1 < paymentProcess.payments.length}]" class="hm-table__td  text-right">{{ payment.amount | toCurrency }} {{ payment.currency }}</div>
        <div :class="[{'hm-table__td--has-child-rows': index+1 < paymentProcess.payments.length}]" class="hm-table__td"></div>
        <div :class="[{'hm-table__td--has-child-rows': index+1 < paymentProcess.payments.length}]" class="hm-table__td text-right">
          <div class="hm-table__td hm-table__td--icon">
            <v-nodes :scoped-vnodes="$scopedSlots.b1" :data="{ paymentProcess: paymentProcess, paymentTransaction: payment }" />
            <v-nodes :scoped-vnodes="$scopedSlots.b2" :data="{ paymentProcess: paymentProcess, paymentTransaction: payment }" />
            <v-nodes :scoped-vnodes="$scopedSlots.b3" :data="{ paymentProcess: paymentProcess, paymentTransaction: payment }" />
          </div>
        </div>
      </template>
      <template>
        <div :class="[{'hm-table__td--has-child-rows': balance > 0}]" class="hm-table__td"></div>
        <div :class="[{'hm-table__td--has-child-rows': balance > 0}]" class="hm-table__td "></div>
        <div :class="[{'hm-table__td--has-child-rows': balance > 0}]" class="hm-table__td  text-right text--bold">{{ $t('table.activePaymentProcess.summaryTotal') }}</div>
        <div :class="[{'hm-table__td--has-child-rows': balance > 0}]" class="hm-table__td  text-right">{{ paymentProcessTotal(paymentProcess) | toCurrency }} {{ hotelSettings.details.currency }}</div>
        <div :class="[{'hm-table__td--has-child-rows': balance > 0}]" class="hm-table__td  hm-table__td--icon">
          <div class="hm-table__td hm-table__td--icon">
            <span v-tooltip="{ title: $t('table.activePaymentProcess.finishPrePayment'), delay: 250, placement: 'bottom', positionFixed: true, trigger: 'hover', touch: false }" v-if="false && canAddAsPrepayment" class="quick-action-button" @click="$emit('addPayment', $event)">
              <icon icon="pre-payment" />
            </span>
            <span v-tooltip="{ title: $t('table.activePaymentProcess.finishPayment'), delay: 250, placement: 'bottom', positionFixed: true, trigger: 'hover', touch: false }" v-if="false && canFinishPaymentProcess" class="quick-action-button" @click="$emit('addPayment', $event)">
              <icon icon="save" />
            </span>
            <span v-tooltip="{ title: $t('table.activePaymentProcess.cancelPayment'), delay: 250, placement: 'bottom', positionFixed: true, trigger: 'hover', touch: false }" class="quick-action-button" @click="paymentProcess.payments = []">
              <icon icon="delete" />
            </span>
          </div>
        </div>
      </template>
      <template v-if="balance > 0">
        <div class="hm-table__td"></div>
        <div class="hm-table__td"></div>
        <div class="hm-table__td text-right text--bold">{{ $t('table.activePaymentProcess.remainingBalance') }}</div>
        <div class="hm-table__td text-right color--red">{{ (balance * -1) | toCurrency }} {{ hotelSettings.details.currency }}</div>
        <div class="hm-table__td">
          <div class="hm-table__td hm-table__td--icon">
          </div>
        </div>
      </template>
    </template>
  </hm-table>
</template>

<script>

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { isArray, join, isNil, isEmpty, groupBy, values, head, cloneDeep, concat, unionBy, reverse, sortBy, last, sumBy } from 'lodash';

export default {
  name: 'ActivePaymentPRocess',

  mixins: [HotelmeisterMixin],

  props: {
    canFinishPaymentProcess: {
      type: Boolean,
      required: false,
      default: false,
    },
    canAddAsPrepayment: {
      type: Boolean,
      required: false,
      default: false,
    },
    paymentProcess: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    created: {
      type: Boolean,
      required: false,
      default: false,
    },
    cancelled: {
      type: Boolean,
      required: false,
      default: false,
    },
    balance: {
      type: Number,
      required: false,
      default: 0,
    },
  },

  data: function () {
    return {
    };
  },

  computed: {
  },

  methods: {
    paymentProcessTotal(paymentProcess) {
      return sumBy(paymentProcess.payments, it => it.amount);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';

</style>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/lib/table/ActivePaymentProcess.vue